import { call, put, select } from 'redux-saga/effects';
import { isNil } from 'ramda';
import {
  fetchUserCurriculumsRequest,
  fetchUserCurriculumsSuccess,
  fetchUserCurriculumsFailed,
  selectCurriculum
} from 'stores/curriculums/actions';
import { setSyllabus } from 'stores/report/actions';
import GetCurriculumForCurrentUser from 'services/curriculums';
import { compareValues } from 'helpers/singleClassReport';
import { sortCurriculums } from 'stores/curriculums/reducer';
// Helper to set default curriculum
const setDefaultCurriculum = curriculumsArray => {
  const sortedCurriculums = curriculumsArray.sort(
    compareValues('CurriculumName', 'asc')
  );
  const feature6DefaultCurriculum = sortedCurriculums.find(
    curr => curr.Feature === 6
  );
  if (feature6DefaultCurriculum) {
    return feature6DefaultCurriculum;
  }
  const defaultCurriculumIndex = sortedCurriculums.findIndex(
    curr => curr.IsDefault === true
  );
  if (defaultCurriculumIndex !== -1) {
    return sortedCurriculums[defaultCurriculumIndex];
  }
  return sortedCurriculums[0];
};

/**
 * The saga to get user curriculum
 */
function* getUserCurriculums() {
  // Check if CountryId exists in profileSettings
  const { profileData } = yield select(state => state.profileSettings);
  const countryId = profileData?.CountryId;

  // If CountryId is not available, skip API call (silently return and wait for CountryId)
  if (isNil(countryId) || countryId === '') {
    return;
  }

  yield put(fetchUserCurriculumsRequest());
  const data = yield call(GetCurriculumForCurrentUser);
  if (!isNil(data)) {
    if (!isNil(data.error)) {
      // if the API return error message
      yield put(fetchUserCurriculumsFailed(data.error));
    } else {
      // Sort data first (for setSyllabus)
      const sortedCurriculums = sortCurriculums(data, countryId);
      // Pass raw data and CountryId to reducer, let reducer handle sorting logic
      yield put(fetchUserCurriculumsSuccess(data, countryId));
      // Get the selectedCurriculum from reducer (it will be set by reducer if empty)
      const { selectedCurriculum } = yield select(state => state.curriculums);
      // Dispatch SELECTED_CURRICULUM action to trigger syllabus saga if curriculum was set
      if (selectedCurriculum.CurriculumID) {
        yield put(selectCurriculum(selectedCurriculum));
      }
      // Use sorted data to set default syllabus
      yield put(setSyllabus(setDefaultCurriculum(sortedCurriculums)));
    }
  }
}

/**
 * Saga to automatically fetch curriculums when CountryId becomes available
 * This listens to FETCH_PROFILE_DATA_SUCCESS
 */
export function* watchProfileDataForCurriculums() {
  // Call getUserCurriculums directly, it will check if CountryId exists internally
  yield call(getUserCurriculums);
}

export default getUserCurriculums;
